import { useState } from 'react'
import useSWR from 'swr'

import { useAuthContext } from '@/context/AuthContext'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { useConfigsContext } from '@/context/ConfigsContext'
import { useWorldCommunityContext } from '@/context/WorldCommunityContext'
import { checkIsFollowed } from '@/lib/community'
import { getCommunityServiceBaseURL } from '@/lib/configs'
import { getFollowingsWithAccountId, postFollow, postUnFollow } from '@/services/community'

export const useToggleFollow = () => {
  const [isFollowed, setIsFollowed] = useState(false)
  const [isButtonEnabled, setIsButtonEnabled] = useState(true)

  const { setFollowersData } = useWorldCommunityContext()
  const { roomData } = useCheckEnterRoomContext()
  const { isSignedIn, handleLogin } = useAuthContext()
  const { store } = useConfigsContext()

  const htcToken = store?.credentials?.htcToken
  const roomOwnerAccountId = roomData.owner.htc_account_id

  const { mutate: mutateFollowingsData } = useSWR(
    !htcToken ? null : 'getFollowingsDataWithAccountId',
    () => getFollowingsWithAccountId(htcToken!),
    {
      onSuccess: (data) => {
        setIsFollowed(checkIsFollowed(data, roomOwnerAccountId))
      },
    },
  )

  const handleToggleFollow = async () => {
    if (!isSignedIn) {
      handleLogin()
      return
    }

    if (!htcToken || !roomOwnerAccountId) {
      console.log(`missing ${!htcToken ? 'htcToken' : 'htcAccountId'}`)
      return
    }

    setIsButtonEnabled(false)

    const followingsData = await mutateFollowingsData()
    const newIsFollowed = checkIsFollowed(followingsData, roomOwnerAccountId)

    if (newIsFollowed !== isFollowed) {
      setIsFollowed(newIsFollowed)
      setFollowersData((prev) => ({
        ...prev!,
        totalItems: prev!.totalItems + (newIsFollowed ? 1 : -1),
      }))
      return
    }

    const communityServiceBaseURL = getCommunityServiceBaseURL()

    const action = isFollowed ? postUnFollow : postFollow
    const targetUserIri = `${communityServiceBaseURL}/users/${roomOwnerAccountId}`
    const postResponse = await action(htcToken, targetUserIri)

    if (postResponse?.status === 200) {
      setIsFollowed(!isFollowed)
      setFollowersData((prev) => ({
        ...prev!,
        totalItems: prev!.totalItems + (isFollowed ? -1 : 1),
      }))
    } else {
      console.error(`${isFollowed ? 'Unfollow' : 'Follow'} user failed:`, postResponse)
    }

    setIsButtonEnabled(true)
  }

  return {
    isFollowed,
    isButtonEnabled,
    handleToggleFollow,
  }
}
